import { StyleSheet, Platform } from 'react-native';
import Colors from '../../constants/Colors';

export const styles = StyleSheet.create({
  photos: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginBottom: 20,
    // backgroundColor: 'pink',
  },
  newPhotoContainer: {
    backgroundColor: Colors.yellow,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center'
  },
  photoPlus: {
    position: 'absolute',
  },

  // test modal styles
  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    // marginTop: -120,
    // backgroundColor: 'rgba(0,0,0,0.55)',
    backgroundColor: Colors.transparentGrey4,
  },
  modalView: {
    marginTop: -120,
    backgroundColor: Colors.blue3,
    borderRadius: 10,
    padding: 15,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    width:'90%',
    // backgroundColor: 'pink',
    ...Platform.select({
      web: {
        maxWidth: 768,
      },
    }),
  },
  // caption: {
  //   borderColor: Colors.darkGrey,
  //   borderWidth: 1,
  //   // borderStyle: 'solid',
  //   marginBottom: 15,
  //   width: '100%',
  //   padding:10,
  //   borderRadius: 10,
  // },
  captionImg: {
    width: '100%',
    // height: 120,
    maxHeight:120,
    borderRadius: 10,
    marginBottom: 15,
  },
  captionModalClose: {
    position: 'absolute',
    top: -10,
    right: -10,
  },
  fullView: {
    // width: '100%',
    // height: '100%',
    // alignItems: 'center',
    // justifyContent: 'center',
    backgroundColor: Colors.blue,
    flex: 1,
  },
  modalImg: {
    width: '100%',
  },
  modalImgLoader: {
    position: 'absolute',
    width: '100%',
    height: '100%',
  },
  imageModalClose: {
    position:'absolute',
    // top:0,
    bottom: 0,
    right:10,
  },
  imageContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundColor: Colors.red,
    // height: '100%',
  },
  captionOverlay: {
    // backgroundColor: Colors.textInputBackground,
    // paddingVertical:20,
    // paddingHorizontal:10,
    // position:'absolute',
    // bottom: 0,
    // left: 0,
    // width: '100%',

    backgroundColor: Colors.textInputBackground,
    // backgroundColor: Colors.yellow,
    paddingVertical: 20,
    paddingHorizontal: 10,
  },
  captionTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // flex: 1,
    marginBottom: 10,
    // backgroundColor: 'blue',
  },
  captionTextContainerInner: {
    flex: 1,
    marginHorizontal: 10,
    // backgroundColor: 'blue',
    // marginBottom: 10,
    minHeight: 26,
    flexDirection: 'row', 
    alignItems: 'center',
    justifyContent: 'center'
  },
  captionText: {
    // flex: 1,
  //   marginHorizontal: 10,
  //   // backgroundColor: 'blue',
  //   // marginBottom: 10,
  //   minHeight: 26,
  },
  backCaptionIconContainer: {
    // position: 'absolute',
    // top: 0,
    // left: 0,
    // backgroundColor: 'red',
  },
  backCaptionIcon: {
    // position: 'absolute',
  },
  editCaptionIcon: {
    // position:'absolute',
    // top:0,
    // right: 0,
    // backgroundColor: 'yellow'
  },
  userDateCountContainer: {
    alignItems: 'flex-end',
    // flex: 1,
  },
  userText: {
    marginBottom: 5
  },
  caretLeft: {
    position: 'absolute',
    left: 0,
    backgroundColor: 'rgba(0,0,0,0.65)',
    padding: 10,
    borderRadius: 100,
  },
  caretRight: {
    position: 'absolute',
    right: 0,
    backgroundColor: 'rgba(0,0,0,0.65)',
    padding: 10,
    borderRadius: 100,
  },
  editCaptionContainer: {
    position: 'absolute',
    top:0,
    left: 0,
    width: '100%',
    height: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: Colors.transparentGrey4,
  },
  pdfInfoOverlay: {
    backgroundColor: Colors.textInputBackground,
    paddingVertical: 20,
    paddingHorizontal: 10,
    // flex: 1,
  },
  notAccepted: {
    position: 'absolute',
    top:10,
    left:10,
  },
  notAcceptedIcon: {
    position:'absolute',
  }
});

export default styles;